var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-dashboard"},[_c('app-header'),_c('app-callouts'),_c('div',{attrs:{"id":"sapp__view"}},[_vm._t("default")],2),_c('app-notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }